<template>
  <div>
    <template v-for="block in blocks">
      <block :block="block" :step="step" :key="block.id" @change="getBlocks" />
    </template>
    <add-block :step="step" @add="getBlocks" />
  </div>
</template>

<script>
import axios from "axios";
import Block from "./Block";
import AddBlock from "./AddBlock";
export default {
  components: {
    Block,
    AddBlock
  },
  props: {
    step: {
      type: Object
    }
  },
  data: () => ({
    blocks: []
  }),

  mounted: function() {
    this.getBlocks();
  },
  methods: {
    async getBlocks() {
      await axios
        .get(
          "service/" +
            this.step.services_id +
            "/step/" +
            this.step.id +
            "/block"
        )
        .then(response => (this.blocks = response.data));
    }
  }
};
</script>

<style lang="scss" scoped>
.step {
  box-shadow: 2px 2px 4px 2px #00000024;
  .header {
    padding: 10px 10px;
    background: rgb(255, 255, 255);
    background: linear-gradient(
      171deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(245, 245, 245, 1) 53%,
      rgba(244, 244, 244, 1) 100%
    );
    border-bottom: 1px solid #cccccc7d;
  }
  .content {
    display: flex;
    .blocks {
      flex: 1 1 90%;
    }
    .actions {
      flex: 0 0 5%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #efefef;
      ul {
        padding: 0;
        margin: 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        li {
          list-style: none;
        }
      }
    }
  }
}
</style>
